import React, { Fragment } from "react";
import { Seo, ScrollTopBtn } from "../components";
import {
  HeaderThree,
  HeroTwo,
  FeatureTwo,
  AboutThree,
  // TeamTwo,
  CounterTwo,
  AboutFour,
  ServiceTwo,
  // ProjectOne,
  // PricePlanOne,
  ContactOne,
  BlogFour,
  ProcessOne,
  BrandTwo,
  FooterTwo,
} from "../containers";

const HomeTwo = () => (
  <Fragment>
    <Seo
      title="Home - Tech Ayukta"
      description="Tech Ayukta delivers modern IT solutions including Web Development, Mobile App Development, ERP Systems, Custom Software, UI/UX Design, Cloud Services, and Digital Transformation to help businesses innovate, automate, and scale."
      keywords="Tech Ayukta, IT Services, Web Development, Mobile App Development, ERP Solutions, Custom Software Development, Software Company, UI/UX Design, Cloud Services, Digital Transformation, Business Automation, Enterprise Software, SaaS Development, Full Stack Development, MERN Stack Development, App Design, Website Design, IT Consulting, Backend Development, Frontend Development, CMS Development, API Integration"
      canonical="https://www.techayukta.com/"
    />

    <HeaderThree />
    <HeroTwo />
    <FeatureTwo className="space-top" />
    <AboutThree />
    {/* <TeamTwo className="space-top space-extra-bottom"/> */}
    <CounterTwo className="space" />
    <AboutFour className="space space-extra-bottom" />
    <ServiceTwo className="space space-extra-bottom" />
    <ProcessOne className="space-top space-extra-bottom" />
    {/* <ProjectOne className="space-top"/> */}
    {/* <PricePlanOne className=" space-extra"/> */}
    <ContactOne />
    <BlogFour className="space-top space-extra-bottom" />
    <BrandTwo className="space" />
    <FooterTwo />
    <ScrollTopBtn />
  </Fragment>
);

export default HomeTwo;

// {
//     "name": "Home",
//     "path": "/",
//     "subMenu": [
//       {
//         "name": "Home One",
//         "path": "/"
//       },
//       {
//         "name": "Home Two",
//         "path": "/home-two"
//       },
//       {
//         "name": "Home Three",
//         "path": "/home-three"
//       }
//     ]
//   },
// {
//     "name": "Blog",
//     "path": "/blog",
//     "subMenu": [
//       {
//         "name": "Blog List",
//         "path": "/blog"
//       },
//       {
//         "name": "Blog Grid",
//         "path": "/blog-grid"
//       },
//       {
//         "name": "Blog Details",
//         "path": "/blog-details"
//       }
//     ]
//   },

// {
//   "name": "Pages",
//   "path": "/",
//   "subMenu": [
//     {
//       "name": "Team",
//       "path": "/team"
//     },
//     {
//       "name": "Team Details",
//       "path": "/team-details"
//     },
//     {
//       "name": "Projects",
//       "path": "/project"
//     },
//     {
//       "name": "Projects Details",
//       "path": "/project-details"
//     },
//     {
//       "name": "Pricing Plans",
//       "path": "/price-plan"
//     },
//     {
//       "name": "Error Page",
//       "path": "/error-page"
//     }
//   ]
// },
